import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function HoverCardDemo() {
  return (
    <Section
      id="hover-card"
      title="HoverCard"
      description="Read-only popover on hover/focus. Use for citation previews, @user mentions."
    >
      <VariantBlock label="Mention preview">
        <p className="text-sm">
          A note from{" "}
          <HoverCard>
            <HoverCardTrigger asChild>
              <a
                href="#hover-card"
                className="font-medium text-primary underline-offset-2 hover:underline"
              >
                @akshit
              </a>
            </HoverCardTrigger>
            <HoverCardContent className="w-72">
              <div className="space-y-2">
                <div className="flex items-baseline justify-between">
                  <strong className="text-sm">Akshit Sanghani</strong>
                  <span className="text-xs text-muted-foreground">
                    @akshit
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  Frontend & design systems · joined 2024 · ships things that
                  ship things.
                </p>
              </div>
            </HoverCardContent>
          </HoverCard>{" "}
          about the v0.2.0 batch.
        </p>
      </VariantBlock>
    </Section>
  );
}
